var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2459_9845",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2459_9845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.9625 13.5C9.225 13.5 9.44687 13.4094 9.62813 13.2281C9.80937 13.0469 9.9 12.825 9.9 12.5625C9.9 12.3 9.80937 12.0781 9.62813 11.8969C9.44687 11.7156 9.225 11.625 8.9625 11.625C8.7 11.625 8.47812 11.7156 8.29687 11.8969C8.11562 12.0781 8.025 12.3 8.025 12.5625C8.025 12.825 8.11562 13.0469 8.29687 13.2281C8.47812 13.4094 8.7 13.5 8.9625 13.5ZM8.2875 10.6125H9.675C9.675 10.2 9.72188 9.875 9.81563 9.6375C9.90938 9.4 10.175 9.075 10.6125 8.6625C10.9375 8.3375 11.1937 8.02812 11.3812 7.73437C11.5687 7.44062 11.6625 7.0875 11.6625 6.675C11.6625 5.975 11.4062 5.4375 10.8937 5.0625C10.3812 4.6875 9.775 4.5 9.075 4.5C8.3625 4.5 7.78437 4.6875 7.34062 5.0625C6.89687 5.4375 6.5875 5.8875 6.4125 6.4125L7.65 6.9C7.7125 6.675 7.85312 6.43125 8.07187 6.16875C8.29062 5.90625 8.625 5.775 9.075 5.775C9.475 5.775 9.775 5.88437 9.975 6.10312C10.175 6.32187 10.275 6.5625 10.275 6.825C10.275 7.075 10.2 7.30937 10.05 7.52812C9.9 7.74687 9.7125 7.95 9.4875 8.1375C8.9375 8.625 8.6 8.99375 8.475 9.24375C8.35 9.49375 8.2875 9.95 8.2875 10.6125ZM9 16.5C7.9625 16.5 6.9875 16.3031 6.075 15.9094C5.1625 15.5156 4.36875 14.9812 3.69375 14.3062C3.01875 13.6312 2.48437 12.8375 2.09062 11.925C1.69687 11.0125 1.5 10.0375 1.5 9C1.5 7.9625 1.69687 6.9875 2.09062 6.075C2.48437 5.1625 3.01875 4.36875 3.69375 3.69375C4.36875 3.01875 5.1625 2.48437 6.075 2.09062C6.9875 1.69687 7.9625 1.5 9 1.5C10.0375 1.5 11.0125 1.69687 11.925 2.09062C12.8375 2.48437 13.6312 3.01875 14.3062 3.69375C14.9812 4.36875 15.5156 5.1625 15.9094 6.075C16.3031 6.9875 16.5 7.9625 16.5 9C16.5 10.0375 16.3031 11.0125 15.9094 11.925C15.5156 12.8375 14.9812 13.6312 14.3062 14.3062C13.6312 14.9812 12.8375 15.5156 11.925 15.9094C11.0125 16.3031 10.0375 16.5 9 16.5Z",
    fill: "#79818A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.c37564c5a17b2cdbeafacec759e2587e.svg";
export { ForwardRef as ReactComponent };